<template>
  <div>
    <MailAttachment v-for="attachment of form.attachments" :key="attachment.uniqueId"
      :availableAttachmentsForCascader="availableAttachmentsForCascader" v-model="attachment.data"
      @remove="removeAttachment(attachment.uniqueId)"></MailAttachment>

    <el-button @click="addEmptyAttachment()" class="el-icon-plus">添加</el-button>

    <el-popover style="margin-left: 20px" placement="top-start" width="631" trigger="click">
      <el-table border :data="availableAttachmentTemplates" max-height="400px">
        <el-table-column align="center" width="200" prop="name" label="名称"></el-table-column>
        <el-table-column align="center" width="350" label="道具">
          <template slot-scope="scope">
            <div v-for="(item, index) in JSON.parse(scope.row.props)" :key="index">
              {{
                availableAttachmentsMappedById[item.id]
                  ? availableAttachmentsMappedById[item.id].name
                  : ""
              }}
              x {{ item.amount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <span style="
                      padding-left: 10px;
                      color: rgb(37, 148, 240);
                      cursor: pointer;
                    " @click="importAttachmentFromTemplate(scope.row)">导入</span>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" plain slot="reference" icon="el-icon-download">从模板导入</el-button>
    </el-popover>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import MailAttachment from "@/pages/mail/components/MailAttachment";

export default {
  data() {
    return {
      form: {
        attachments: [],
      },
      attachmentUniqueId: 0,
      availableAttachmentsForCascader: [],
      availableAttachmentTemplates: [],
      availableAttachmentsMappedById: {},
    }
  },

  props: {
    attachments: Array,
  },

  components: {
    MailAttachment,
  },

  async created() {
    await this.loadAvailableAttachmentTemplates();
    await this.loadAvailableAttachments();

    if (this.attachments) {
      for (let a of this.attachments) {
        this.addAttachment(a.id, a.num);
      }
    }
  },

  methods: {
    /**
     * 获取数据
     * 
     * 这个函数是供父组件直接调用的
     */
    getData() {
      let result = {
        errorMessage: "",
        data: {
          attachments: [],
        }
      };

      for (let e of this.form.attachments) {
        if (e.data.valuesOfNodes.length == 0) {
          result.errorMessage = "请正确选择附件";
          return result;
        }

        let id = e.data.valuesOfNodes[1];
        let num = e.data.number;

        if (!id) {
          result.errorMessage = "请正确选择附件";
          return result;
        }

        if (!num) {
          result.errorMessage = "附件的数目必须大于0";
          return result;
        }

        result.data.attachments.push({
          id: id,
          num: num,
        })
      }

      return result;
    },

    /**
     * 查询所有的附件模板
     */
    async loadAvailableAttachmentTemplates() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryMailPropsTemplate`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let listInResponse = resData.data.list || [];

      for (let t of listInResponse) {
        this.availableAttachmentTemplates.push({
          name: t.name,
          props: t.props,
        });
      }
    },

    /**
     * 查询所有的可作为附件的道具
     */
    async loadAvailableAttachments() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: false,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      for (let category of resData.data.categories) {
        this.availableAttachmentsForCascader.push({
          label: category.name,
          value: category.name,
          children: (() => {
            let result = [];
            for (let e of category.entries) {
              result.push({
                label: e.name,
                value: e.id,
              });
            }
            return result;
          })(),
        });
      }

      for (let category of resData.data.categories) {
        for (let e of category.entries) {
          this.availableAttachmentsMappedById[e.id] = {
            name: e.name,
            categoryName: category.name,
          };
        }
      }
    },

    /**
     * 增加一个空附件
     */
    addEmptyAttachment() {
      this.addAttachment(0, 1);
    },

    /**
     * 增加一个指定附件
     */
    addAttachment(id, num) {
      let valuesOfNodes = [];
      if (this.availableAttachmentsMappedById[id]) {
        valuesOfNodes = [this.availableAttachmentsMappedById[id].categoryName, id];
      }

      this.form.attachments.push({
        uniqueId: ++this.attachmentUniqueId,
        data: {
          valuesOfNodes: valuesOfNodes,
          number: num,
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachment(uniqueId) {
      for (let i = 0; i < this.form.attachments.length; i++) {
        if (this.form.attachments[i].uniqueId == uniqueId) {
          this.form.attachments.splice(i, 1);
          break;
        }
      }
    },

    /**
     * 从附件模板导入附件
     */
    importAttachmentFromTemplate(attachmentTemplate) {
      let props = JSON.parse(attachmentTemplate.props);
      for (let item of props) {
        this.addAttachment(item.id, item.amount);
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>